import axios, { AxiosResponse } from 'axios'
import axiosInstanceApiGateway from 'config/apiServiceApiGateway'

const { REACT_APP_BASE_URL_API } = process.env
const baseUrl = REACT_APP_BASE_URL_API

export const getPackageId = (): string => '/api/package-id'

export const createPackageId = (): string => 'api/package-id'

export const checkPackageId = (): string => 'api/package-id/scan'

export const checkPackageIdByApi = (params: Record<string, unknown>): Promise<AxiosResponse> =>
  axiosInstanceApiGateway.Get({ url: '/wims/internal/v1/package-ids/details', params })

export const getPackageIdSingle = (query = ''): Promise<AxiosResponse> =>
  axios.get(`${baseUrl}/api/package-id/${query}`)

export const fetchCheckPackageIdAPI = (params: Record<string, unknown>): Promise<AxiosResponse> =>
  axios.get(`${baseUrl}/api/package-id/scan`, { params })
